export default class Modal {
  _modalElement = null
  _modalBody = null
  _placeholder = null
  _originalParent = null

  open(contentRef) {
    // Créer le modal si ce n'est pas déjà fait
    if (!this._modalElement) {
      this._modalElement = document.createElement('div')
      this._modalElement.className = `
        fixed inset-0 bg-black bg-opacity-40 flex justify-center items-center z-50
        modal-overlay
      `
      this._modalElement.innerHTML = `
        <div class="bg-white rounded-lg p-6 max-w-[90%] max-h-[80%] overflow-auto relative modal-content">
          <button class="absolute top-2 right-2 text-gray-600 hover:text-gray-900 modal-close">✕</button>
          <div class="modal-body"></div>
        </div>
      `
      document.body.appendChild(this._modalElement)

      this._modalBody = this._modalElement.querySelector('.modal-body')

      // Listeners pour fermer
      this._modalElement
        .querySelector('.modal-close')
        .addEventListener('click', () => this.close())
      this._modalElement.addEventListener('click', e => {
        if (e.target === this._modalElement) this.close()
      })
    }

    // Sauvegarder position originale
    this._originalParent = contentRef.parentNode
    this._placeholder = document.createElement('div')
    this._originalParent.insertBefore(this._placeholder, contentRef)

    // Déplacer le contenu dans le modal
    this._modalBody.appendChild(contentRef)

    this._modalElement.style.display = 'flex'
  }

  close() {
    if (!this._modalElement || !this._originalParent) return

    const contentRef = this._modalBody.firstChild
    if (contentRef) {
      this._originalParent.insertBefore(contentRef, this._placeholder)
      this._placeholder.remove()
      this._placeholder = null
      this._originalParent = null
    }

    this._modalElement.style.display = 'none'
  }
}
